import React, { useEffect, useState } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { IoWarning } from "react-icons/io5";
import { useParams } from "react-router-dom";
import { serverInstance } from "../../service/axios";
import "./post.scss";

class PostModel {
  id
  title
  description
  dt
  location
  fileUrl
}

const Post = ({ data }) => {
  const params = useParams();
  const [post, setPost] = useState(new PostModel());
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (params.id && !post.fileUrl) {
      serverInstance.post("/app/item", { class: "post", id: params.id }, {
        headers: {
          "Content-Type": "application/json",
        }
      })
      .then(res => {
        res.data.item.fileUrl = `https://lingo-portal-assets.s3.ap-northeast-2.amazonaws.com/${res.data.item.fileUrl}`;
        setPost(res.data.item)
        setLoading(false);
        setErrorMsg("");
      })
      .catch((err) => {
        setLoading(false);
        setErrorMsg(err);
      })
    }
  }, [params.id]);

  return (
    <div className="post">
      {loading ? <>
        <AiOutlineLoading3Quarters size={25} className="loading-spinner"/>
      </>
      :
      <>
        {errorMsg ?
        <div className="error-msg">
          <IoWarning/>
          &nbsp;
          {errorMsg}
        </div>: null}
          
        <div className="event-details">
          <h2>{post.title}</h2>
          <div className="event-desc">{post.description}</div>
          <div className="event-img">
            <img src={post.fileUrl} />
          </div>
        </div>
      </>
      }
    </div>
  );
}

export default Post;